// ---------------------------------------------------------------------------
// Sarvaguna website: ALL text lives in this file.
// To change wording later, edit here only. Pages never hold their own copy.
//
// Fields marked  TODO  are left empty on purpose. The site hides anything
// that is empty, so no placeholder ever shows on the live site.
// ---------------------------------------------------------------------------
export const brand = {
  name: 'Sarvaguna Foods & Kitchen',
  short: 'Sarvaguna',
  // EMERGENT: set this to the existing logo file in the project (the सर्वगुण oval).
  // Leave '' to use the built-in text mark.
  logo: '/assets/sarvaguna-logo.svg',
};
export const contact = {
  phone: '+977 9802856413',
  phoneHref: 'tel:+9779802856413',
  whatsappHref: 'https://wa.me/9779802856413',
  email: 'info@sarvagunakitchen.com',
  kitchenLabel: 'Central kitchen',
  kitchen: 'Budibazaar, Pokhara, Nepal',
  hours: ['Sunday to Friday, 6 am to 8 pm', 'Saturday closed'],
  mapEmbed: 'https://www.google.com/maps?q=Budibazaar%2C%20Pokhara%2C%20Nepal&output=embed',
  // EMERGENT: copy the four social links from the current footer.
  social: { facebook: '', instagram: '', linkedin: '', x: '' },
};
export const nav = [
  { label: 'What we do', to: '/what-we-do' },
  { label: 'How we work', to: '/how-we-work' },
  { label: 'Partner with us', to: '/partner-with-us' },
  { label: 'Academy & Jobs', to: '/academy' },
  { label: 'About us', to: '/about' },
];
export const interests = [
  'School meals',
  'Hospital catering',
  'Events & corporate',
  'Products or bulk order',
  'Sarvaguna in my city',
  'Academy',
  'Jobs',
  'Funding or investment',
  'Something else',
];
// ---------------------------------------------------------------- HOME
export const home = {
  meta: {
    title: 'Sarvaguna Foods & Kitchen | School and hospital catering in Nepal',
    description:
      'Fresh, balanced meals for schools and hospitals, cooked in our central kitchen and served in satellite kitchens in Pokhara. Catering, products, and partnerships across Nepal.',
  },
  hero: {
    eyebrow: 'Mass catering social business · Nepal',
    title: 'Good food for every school day.',
    lead: 'Sarvaguna cooks fresh, balanced meals for schools, hospitals and institutions. Built in Pokhara, growing across Nepal.',
    proof: 'More than 9,000 fresh meals cooked every day',
  },
  intro: {
    eyebrow: 'Who we are',
    title: 'A Nepali kitchen you can rely on',
    text: [
      'Sarvaguna Foods & Kitchen is a catering company for schools, hospitals and institutions. Every meal is cooked fresh in our own central kitchen, served in satellite kitchens, planned by our nutritionist and chefs, and made with produce from local farms wherever we can.',
      'Public and private schools and a teaching hospital in Pokhara count on us every day.',
    ],
  },
  services: {
    eyebrow: 'What we do',
    title: 'Meals for every kind of kitchen',
  },
  promise: {
    eyebrow: 'Our promise',
    title: 'Safe, balanced, local.',
    items: [
      // TODO: name your food safety licence or standard in `withLicence`
      // (e.g. 'Prepared under [licence name] in our own central kitchen.').
      { title: 'Safe.', text: 'Hygienic preparation in our own central and satellite kitchens.', withLicence: '' },
      { title: 'Balanced.', text: 'Every menu is planned by our nutritionist and chef.' },
      { title: 'Local.', text: 'We buy from Nepali farmers first.' },
    ],
  },
  partner: {
    title: 'Want Sarvaguna in your city / community?',
    text: 'We work with municipalities, school networks, hospitals and local entrepreneurs to set up central kitchens and canteens.',
  },
  academy: {
    eyebrow: 'Academy & Jobs',
    title: 'Learn catering in a real kitchen.',
    text: 'A 24-month apprenticeship in our central and satellite kitchens, ending in a job or support to run your own satellite kitchen (franchise).',
  },
  trusted: {
    eyebrow: 'Trusted by schools and hospitals',
  },
};
// ---------------------------------------------------------------- SERVICES
export const services = [
  {
    slug: 'schools',
    art: 'thali',
    title: 'Schools',
    short: 'Balanced and tasty lunches children actually eat.',
    meta: {
      title: 'School meals | Sarvaguna Foods & Kitchen',
      description: 'Balanced school lunches planned by a nutritionist, cooked fresh by qualified chefs each morning and delivered on time.',
    },
    eyebrow: 'School meals',
    headline: 'School meals children look forward to eating.',
    lead: 'Balanced lunches planned by our nutritionist, cooked fresh each morning and delivered to your school on time.',
    detailTitle: 'What your school gets',
    ticks: ['Menus approved by our nutritionist', 'Tasty meals prepared by professional chefs', 'Fresh, local ingredients', 'Options for children with dietary needs', 'Delivery on time, every school day'],
    servedTitle: 'Who we cook for',
    served: '22 private schools and 3 public schools in Pokhara.',
    // NOTE: check these steps match how you take on a new school.
    stepsTitle: 'How a school joins',
    steps: [
      { title: 'Talk to us', text: 'We visit your school and agree numbers, timing and budget.' },
      { title: 'Plan the menu', text: 'Our nutritionist and chefs plan a menu that suits your students’ ages.' },
      { title: 'Start serving', text: 'We cook each morning in our central kitchen and deliver on time.' },
      { title: 'Review together', text: 'We check in every term and adjust the menu with you.' },
    ],
    menuPdf: '', // TODO: link to a sample weekly menu PDF
    person: { name: '', role: 'School partnerships', photo: '' }, // TODO: name + portrait
  },
  {
    slug: 'hospitals',
    art: 'tray',
    title: 'Hospitals',
    short: 'Meals for patients, staff and students.',
    meta: {
      title: 'Hospital catering | Sarvaguna Foods & Kitchen',
      description: 'Hospital canteen catering with hygienic preparation, special diets and flexible meal times.',
    },
    eyebrow: 'Hospital catering',
    headline: 'Hospital meals planned around people’s needs.',
    lead: 'We run the canteen at Manipal Teaching Hospital, serving more than 600 medical students and staff every day.',
    detailTitle: 'What we provide',
    ticks: ['Hygienic preparation', 'Special dietary options', 'Flexible meal times', 'Menus planned by our nutritionist and chefs'],
    servedTitle: 'Where we cook today',
    served: 'Manipal Teaching Hospital, Pokhara.',
    steps: [],
    person: { name: '', role: 'Hospital catering', photo: '' }, // TODO
  },
  {
    slug: 'events',
    art: 'buffet',
    title: 'Events & corporate',
    short: 'Catering and boxed meals for any size of gathering.',
    meta: {
      title: 'Event and corporate catering | Sarvaguna Foods & Kitchen',
      description: 'Catering for corporate functions and community gatherings, plus boxed meals delivered in bulk.',
    },
    eyebrow: 'Events & corporate',
    headline: 'Catering for gatherings of any size.',
    lead: 'From office functions to community celebrations, we have catered more than 2,500 events.',
    detailTitle: 'What we offer',
    ticks: ['Custom menus for your event', 'Service staff on the day', 'Boxed meals delivered in bulk', 'Volume pricing for regular orders'],
    servedTitle: 'Boxed meals',
    servedArt: 'boxes',
    served: 'More than 250,000 meal boxes delivered to businesses and institutions.',
    steps: [],
    person: { name: '', role: 'Events & orders', photo: '' }, // TODO
  },
  {
    slug: 'products',
    art: 'shelf',
    title: 'Products',
    short: 'Bakery, noodles, flour, pickles and Yogi Boost.',
    meta: {
      title: 'Sarvaguna Foods products',
      description: 'Multigrain and millet bakery, noodles, flour mixes, Nepali pickles and Yogi Boost drinks.',
    },
    eyebrow: 'Sarvaguna Foods',
    headline: 'Everyday foods made from Nepali grains and produce.',
    lead: 'The same kitchen that cooks for schools makes a small range of foods for homes, shops and institutions.',
    products: [
      { name: 'Bakery', art: 'bakery', text: 'Multigrain and millet-based breads and biscuits.' },
      { name: 'Noodles', art: 'noodles', text: 'Multigrain noodles.' },
      { name: 'Yogi Boost', art: 'yogiboost', text: 'Nutritious drinks.' },
      { name: 'Multigrain flour', art: 'flour', text: 'Flour mixes, including custom blends.' },
      { name: 'Pickles', art: 'pickles', text: 'Traditional Nepali achar.' },
      // { name: 'Sweets & Bites', text: '' },  // add when the outlets open
    ],
    whereToBuy: '', // TODO: where people can buy (shops, outlets, online)
    person: { name: '', role: 'Products & bulk orders', photo: '' }, // TODO
  },
];
export const whatWeDo = {
  meta: {
    title: 'What we do | Sarvaguna Foods & Kitchen',
    description: 'School meals, hospital catering, events and boxed meals, and Sarvaguna Foods products.',
  },
  eyebrow: 'What we do',
  title: 'One kitchen, four ways we feed people.',
  lead: 'Everything is cooked in our central kitchen and delivered fresh.',
};
// ---------------------------------------------------------------- HOW WE WORK
export const howWeWork = {
  meta: {
    title: 'How we work | Sarvaguna Foods & Kitchen',
    description: 'Food safety, nutrition, local sourcing and the people behind every Sarvaguna meal.',
  },
  eyebrow: 'How we work',
  title: 'One central kitchen, many satellite kitchens/​canteens.',
  lead: 'We buy from farmers, cook in one central kitchen and deliver to school and hospital canteens, served through satellite kitchens. The same model can be set up in other districts.',
  model: [
    { title: 'Farmers', text: 'Produce bought directly from local growers.' },
    { title: 'Central kitchen', text: 'Storage, milling, cooking and packing in Budibazaar, Pokhara.' },
    { title: 'Canteens', text: 'Meals delivered fresh to schools and hospitals.' },
    { title: 'Academy', text: 'Apprentices trained in the kitchen for jobs or their own satellite kitchen.' },
  ],
  sections: [
    {
      id: 'food-safety',
      art: 'kitchen',
      title: 'Food safety',
      text: 'Every meal is prepared in our own central kitchen, where we control storage, cooking and packing. Food travels to canteens in temperature-controlled delivery.',
      licence: '', // TODO: licence or standard name, shown when filled
    },
    {
      id: 'nutrition',
      art: 'nutrition',
      title: 'Nutrition',
      text: 'Menus are calculated and planned by our nutritionist and professional chefs for the age and needs of the people we feed. We use no artificial additives.',
    },
    {
      id: 'local-sourcing',
      art: 'farmer',
      title: 'Local sourcing',
      text: 'We buy directly from more than 500 local farmers. Today about half of everything we buy is grown locally, around 12,000 kg each month, and we are working to raise that share.',
    },
    {
      id: 'our-people',
      art: 'apprentice',
      title: 'Our people',
      text: 'More than 100 people work at Sarvaguna, and 60% of them are women. Our Academy trains the next generation of cooks inside the kitchen.',
    },
  ],
};
// ---------------------------------------------------------------- PARTNER WITH US
export const partner = {
  meta: {
    title: 'Partner with us | Sarvaguna Foods & Kitchen',
    description: 'Bring Sarvaguna’s central-to-satellite kitchen model to your district, open a satellite kitchen, or fund our growth.',
  },
  eyebrow: 'Partner with us',
  title: 'Bring Sarvaguna to your city.',
  lead: 'Our first central kitchen is in Pokhara. We are looking for partners to build the same model in other parts of Nepal.',
  whoTitle: 'Who we work with',
  who: [
    { title: 'Municipalities and education offices', text: 'School meal programmes for public schools in your area.' },
    { title: 'School networks and hospitals', text: 'Catering for a group of schools or a hospital canteen.' },
    { title: 'Local entrepreneurs', text: 'Run a satellite kitchen with our recipes, systems and training. Academy graduates are welcome.' },
    { title: 'Funders and investors', text: 'Help us open new kitchens. See our figures below.' },
  ],
  // NOTE: check these steps match how you would set up a new district.
  stepsTitle: 'How it works',
  steps: [
    { title: 'Talk to us', text: 'Tell us about the schools, hospitals or people you want to feed.' },
    { title: 'Assess together', text: 'We look at demand, a site and local suppliers with you.' },
    { title: 'Set up', text: 'We help set up the kitchen, systems and training.' },
    { title: 'Run and check', text: 'A local team cooks with our recipes and quality checks.' },
  ],
  funders: {
    id: 'funders',
    title: 'For funders and investors',
    asOf: '2026', // TODO: set month and year, e.g. 'October 2026'
    facts: [
      { value: '9,000+', label: 'meals cooked every day' },
      { value: '26', label: 'schools and hospitals served' },
      { value: '500+', label: 'farmers we buy from' },
      { value: '100+', label: 'jobs, 60% held by women' },
      { value: '12,000 kg', label: 'local produce bought each month' },
      { value: '45+', label: 'apprentices trained or in training' },
    ],
    goalsTitle: 'Our goals for 2030',
    goals: [
      { value: '40,000', label: 'meals a day' },
      { value: '6,500', label: 'farmers' },
      { value: '375', label: 'jobs' },
      // TODO: confirm the unit (per year?) before this shows correctly
      { value: '2,000 tonnes', label: 'local produce a year' },
    ],
    profilePdf: '', // TODO: link to a downloadable company profile PDF
  },
};
// ---------------------------------------------------------------- ACADEMY
export const academy = {
  meta: {
    title: 'Sarvaguna Academy and jobs',
    description: 'A 24-month catering apprenticeship in our working central and satellite kitchens in Pokhara, and open jobs at Sarvaguna.',
  },
  eyebrow: 'Sarvaguna Academy',
  title: 'Learn catering in a real kitchen.',
  lead: 'A 24-month dual vocational education for young people, learning by doing in our central and satellite kitchens.',
  learnTitle: 'What apprentices get',
  learn: [
    'Training in mass catering and food service',
    'Hands-on work in a professional central kitchen',
    'A recognised certificate at the end',
    'A job with us, or support to open a satellite kitchen',
  ],
  batchesTitle: 'Batches',
  batches: [
    { name: 'First batch', when: 'Dec 2023 – Jun 2025', note: '15 apprentices completed' },
    { name: 'Second batch', when: 'Jul 2025 – Jun 2027', note: '18 apprentices in training' },
    // TODO: next intake. Leave when '' to hide this row.
    { name: 'Third batch', when: 'Jul 2026 – Jun 2028', note: '20 apprentices in training' },
  ],
  whoCanApply: '', // TODO: age, education, other requirements
  stipend: '', // TODO: stipend or cost, if any
  jobsTitle: 'Jobs at Sarvaguna',
  jobs: [], // TODO: { title, type, text } for each open job
  noJobs: 'No open positions right now. Send your CV to info@sarvagunakitchen.com and we will keep it on file.',
};
// ---------------------------------------------------------------- ABOUT
export const about = {
  meta: {
    title: 'About us | Sarvaguna Foods & Kitchen',
    description: 'Our story, team and partners. Sarvaguna is part of the Development Voyage group.',
  },
  eyebrow: 'About us',
  title: 'Cooking for Pokhara since 2022.',
  story: [
    'Sarvaguna started as a small kitchen for one school in Pokhara in 2022 with one idea: school and hospital meals should be fresh, balanced and made from food grown nearby.',
    'Today our central and satellite kitchens cook for 25 schools and a teaching hospital, buy from hundreds of local farmers, and train young cooks through Sarvaguna Academy.',
  ],
  nameTitle: 'Our name',
  name: 'सर्वगुण (Sarvaguna) means “all good qualities”. It is what we want every meal to have.',
  vision: 'A Nepal where every student eats a nutritious meal at school, every farmer gets a fair price, and every community has access to good food.',
  teamTitle: 'Our team',
  team: [
    // photo: '' shows initials. Add real portraits when you have them.
    { name: 'Tulsi Giri', role: 'Co-founder, Strategy', photo: '' },
    { name: 'Sunil Sharma', role: 'Co-founder, CEO', photo: '' },
    { name: 'Usha Poudel Giri', role: 'Co-founder, PR', photo: '' },
    { name: 'Patrick Honauer', role: 'Partner and mentor', photo: '' },
    { name: 'Santosh Parajuli', role: 'Finance lead (CA)', photo: '' },
    { name: 'Sudeep Neupane', role: 'Chef, production', photo: '' },
    { name: 'Dr. Keshav Bhattarai', role: 'Nutrition and R&D', photo: '' },
    { name: 'Anju Tamrakar', role: 'Academy coordinator', photo: '' },
  ],
  partnersTitle: 'Partners and supporters',
  partners: [
    {
      group: 'Foundations and networks',
      items: [
        ['Association Food Networks', 'Switzerland'],
        ['Hamasil Foundation', 'Zurich'],
        ['Cuisine sans frontières', 'Zurich'],
        ['Fontana Foundation', 'Zurich'],
        ['Social Gastronomy Movement', 'Global network'],
      ],
    },
    { group: 'Impact investors', items: [['LendForGood / Red Hat Impact', 'Australia']] },
    {
      group: 'Government and associations',
      items: [
        ['Education Department', 'Kaski'],
        ['Agriculture Department', 'Kaski'],
        ['PABSON', 'School association'],
        ['N-PABSON', 'School association'],
        ['Government schools programme', 'Nepal'],
      ],
    },
  ],
  groupTitle: 'Part of the Development Voyage group',
  group: 'Sarvaguna is part of the Development Voyage group, alongside its other spin-offs: DV Excellus (Kheti.farm), THE BAZAAR Cooperative and Nepal Food Networks.',
};
// ---------------------------------------------------------------- CLIENTS
// Shown as text until you have permission to use their logos.
export const clients = [
  'Manipal Teaching Hospital',
  'Bindhyabasini High School',
  'JCA School',
  'Amarshing High School',
  'Barahi High School',
  'Kalika Multiple Campus',
  'Srijana Boarding School',
  'Tarakunj Secondary School',
  '& many more',
];
// TODO: one real quote with permission. Leave text '' to hide the block.
export const quote = { text: '', name: '', role: '' };
// ---------------------------------------------------------------- CONTACT
export const contactPage = {
  meta: {
    title: 'Contact | Sarvaguna Foods & Kitchen',
    description: 'Talk to Sarvaguna about school meals, hospital catering, events, products or partnerships anywhere in Nepal.',
  },
  eyebrow: 'Contact',
  title: 'Talk to us.',
  lead: 'Tell us what you need. We reply within 24 hours, by email or WhatsApp.',
  sent: 'Thank you. We have your message and will reply within 24 hours.',
  failed: 'Sorry, that did not send. Please call or WhatsApp us instead.',
};
// ---------------------------------------------------------------- STORIES
export const storiesPage = {
  meta: {
    title: 'Stories | Sarvaguna Foods & Kitchen',
    description: 'News and stories from Sarvaguna’s kitchen, schools, farmers and Academy.',
  },
  eyebrow: 'Stories',
  title: 'From our kitchen.',
};
// Category decides the illustration on the card (no stock photos).
export const storyArt = {
  'Event Catering': 'buffet',
  'Social Impact': 'kitchen',
  'Hospital Catering': 'tray',
  Academy: 'apprentice',
  'Food Networks': 'farmer',
  'School Feeding': 'thali',
};
// EMERGENT: keep the BODY text of the existing six posts. Use these titles
// and excerpts for the four below, and add the Food Networks and School
// Feeding posts in the same shape. body = array of paragraphs.
export const stories = [
  {
    slug: 'event-catering',
    category: 'Event Catering',
    title: 'Event catering: more than 1,370 events so far',
    excerpt: 'From office functions to community celebrations, how we plan menus and service for events of every size.',
    body: [
      'Since 2022, Sarvaguna Foods & Kitchen has catered over 1,370 events across Pokhara and Gandaki Province. From intimate gatherings to large corporate functions, we bring the same commitment to quality and service.',
      '## Our Event Services',
      '### Corporate Events\n- Board meetings and conferences\n- Employee appreciation lunches\n- Training workshops\n- Client entertainment',
      '### Social Gatherings\n- Wedding receptions\n- Birthday celebrations\n- Anniversary parties\n- Community festivals',
      '### Institutional Events\n- School functions\n- College events\n- Hospital celebrations\n- NGO meetings',
      '## What Sets Us Apart',
      '### Custom Menu Design\nWe work with you to create menus that match your:\n- Budget\n- Dietary requirements\n- Theme and style\n- Guest preferences',
      '### Professional Service\n- Trained serving staff\n- Elegant presentation\n- Punctual delivery\n- Clean-up services',
      '### Scalable Solutions\nFrom 20 to 2,000 guests, we scale seamlessly:',
      '| Event Size | Setup Time | Staff Provided |\n|------------|------------|----------------|\n| 20-50 | 2 hours | 3-5 |\n| 50-200 | 4 hours | 8-15 |\n| 200-500 | 6 hours | 20-35 |\n| 500+ | 8 hours | Custom |',
      '## Popular Menu Options',
      '**Nepali Traditional**\n- Dal Bhat with seasonal vegetables\n- Momo (steam/fried)\n- Sel roti and sweets',
      '**Continental**\n- Pasta stations\n- Grilled options\n- Fresh salads',
      '**Fusion**\n- Indo-Chinese\n- Pizza and snacks\n- Custom combinations',
      '## Book Your Event',
      '**Contact our events team:**\n- Phone: +977-9802856413\n- Email: events@sarvagunakitchen.com',
      '**We recommend booking:**\n- Small events: 1 week advance\n- Medium events: 2-3 weeks advance\n- Large events: 1 month advance',
    ],
  },
  {
    slug: 'women-in-our-kitchen',
    category: 'Social Impact',
    title: 'Why most of our kitchen team are women',
    excerpt: 'Sixty percent of the people who work at Sarvaguna are women. What that looks like day to day in a busy kitchen.',
    body: [
      "In Nepal, women's workforce participation remains a challenge due to various social and economic factors. At Sarvaguna Foods & Kitchen, we are actively working to change this narrative.",
      '## Our Commitment',
      'Since our founding, we have prioritized hiring and supporting women:',
      '- **60% Women Workforce**: Across all levels of our organization\n- **Equal Pay**: Same pay for same work, regardless of gender\n- **Flexible Hours**: Accommodating family responsibilities\n- **Safe Workplace**: Zero tolerance for harassment',
      '## Women in Leadership',
      'Our leadership team includes:\n- Kitchen Supervisors: 4 out of 6 are women\n- Quality Control: Led by women professionals\n- Customer Relations: Predominantly women-led',
      '## Success Stories',
      '### Maya Poudel, Kitchen Supervisor\n"I started as a helper 2 years ago. Today, I supervise a team of 15 people. Sarvaguna believed in me when no one else did."',
      '### Gita Rana, Quality Controller\n"As a single mother, finding stable employment was difficult. Sarvaguna gave me not just a job, but a career path."',
      '## Support Programs',
      'We provide additional support:',
      '- **Childcare Assistance**: Partnership with local daycare\n- **Health Insurance**: Comprehensive coverage for all employees\n- **Skill Development**: Regular training and certification programs\n- **Mentorship**: Senior women mentoring new joiners',
      '## The Ripple Effect',
      'When women earn:\n- Families eat better\n- Children stay in school longer\n- Communities become stronger\n- The economy grows',
      '## Join Our Team',
      "We are always looking for talented women to join our team. Whether you're experienced or just starting out, we have opportunities for you.",
      'Apply at careers@sarvagunakitchen.com',
    ],
  },
  {
    slug: 'manipal-teaching-hospital',
    category: 'Hospital Catering',
    title: 'Feeding a teaching hospital',
    excerpt: 'More than 600 medical students and staff eat with us every day at Manipal Teaching Hospital. How we plan their meals.',
    body: [
      'Healthcare environments demand the highest standards of food safety and nutrition. At Sarvaguna, we have partnered with Manipal Teaching Hospital to provide meals that support healing and wellbeing.',
      '## The Healthcare Challenge',
      'Hospital catering is uniquely challenging:\n- Strict hygiene requirements\n- Dietary restrictions for various conditions\n- Long service hours\n- High-stress environment for staff',
      '## Our Solution',
      '### Food Safety First\nOur central kitchen operates under HACCP guidelines:\n- Temperature monitoring at every stage\n- Allergen management protocols\n- Regular staff health checks\n- Third-party quality audits',
      '### Nutritionally Optimized\nOur hospital menus are designed with healthcare in mind:\n- Low sodium options\n- Diabetic-friendly meals\n- High-protein recovery meals\n- Fresh fruits and vegetables daily',
      '## Daily Operations',
      '**Breakfast**: 6:00 AM - 8:00 AM\n- Fresh fruits, proteins, and whole grains\n- Hot beverages and hydration options',
      '**Lunch**: 12:00 PM - 2:00 PM\n- Main course with rice/roti\n- Vegetable sides and dal\n- Dessert options',
      '**Snacks**: 4:00 PM - 5:00 PM\n- Light, energizing options for busy staff',
      '**Dinner**: 7:00 PM - 9:00 PM\n- Balanced meals for overnight staff',
      '## Impact at Manipal',
      '- **Serving**: 600+ people daily\n- **Satisfaction Rate**: 92%\n- **Food Safety Incidents**: Zero in 2 years\n- **Menu Variety**: 30+ rotating dishes',
      '## Expand to Your Healthcare Facility',
      'Looking for reliable hospital catering? We offer:\n- Custom menu development\n- Dietary consultation\n- HACCP-compliant operations\n- Flexible service hours',
      'Contact us at healthcare@sarvagunakitchen.com',
    ],
  },
  {
    slug: 'sarvaguna-academy',
    category: 'Academy',
    title: 'Inside Sarvaguna Academy',
    excerpt: 'Our 24-month apprenticeship trains young people in a working central kitchen. Meet some of our apprentices.',
    body: [
      "Youth unemployment is one of Nepal's biggest challenges. At Sarvaguna Academy, we are turning this challenge into an opportunity by training young people for careers in the food service industry.",
      '## The 24-Month Journey',
      'Our comprehensive program combines:',
      '### Academic Learning (40%)\n- Food safety and hygiene (HACCP standards)\n- Nutrition and menu planning\n- Business and operations management\n- Customer service excellence',
      '### Hands-On Training (60%)\n- Kitchen operations in our central facility\n- Food preparation and cooking techniques\n- Quality control and inventory management\n- Leadership and team management',
      '## Our Batches',
      '**Batch 1 (Dec 2023 - Jun 2025)**: 15 apprentices - Completed\n**Batch 2 (Jul 2025 - Jun 2027)**: 18 apprentices - Currently ongoing\n**Batch 3 (Jul 2026)**: 15 spots available - Apply now!',
      '## Success Stories',
      '### Sita Gurung, Batch 1 Graduate\n"Before joining Sarvaguna Academy, I had no formal skills. Now I\'m a supervisor managing a team of 5 people. The training changed my life."',
      '### Ramesh Thapa, Batch 1 Graduate\n"I came from a farming family with no exposure to the food industry. Today, I\'m helping design menus that feed thousands of children."',
      '## Employment Rate: 100%',
      "All our graduates find employment either within Sarvaguna or with our partner organizations. We're proud to say that 100% of our Batch 1 graduates are employed.",
      '## Apply Now',
      'Are you between 18-25 years old and passionate about food? Apply for our Third Batch starting July 2026.',
      '**Requirements:**\n- Minimum SLC/SEE passed\n- Willingness to commit 24 months\n- Passion for food and service',
      'Apply at academy@sarvagunakitchen.com',
    ],
  },
  {
    slug: 'empowering-farmers',
    category: 'Food Networks',
    title: 'Farm to Table: Empowering 500+ Local Farmers Through Direct Procurement',
    excerpt: 'Learn how our direct sourcing model is creating sustainable livelihoods for smallholder farmers while ensuring fresh, quality ingredients for our meals.',
    body: [
      'In a world where farmers often struggle to get fair prices for their produce, Sarvaguna Foods & Kitchen has built a revolutionary farm-to-table model that puts farmers first.',
      '## Breaking the Middleman Chain',
      'Traditionally, farmers in Nepal sell their produce through multiple intermediaries, losing significant value at each step. Our direct procurement model eliminates these middlemen, ensuring:',
      '- **Fair Prices**: Farmers receive 20-30% more than market rates\n- **Guaranteed Purchase**: We commit to buying specified quantities, reducing farmer uncertainty\n- **Quality Guidance**: Our team works with farmers on best practices for better yields',
      '## Our Farmer Network',
      'We have connected with 500+ smallholder farmers across Gandaki Province:',
      '- **Vegetables**: 150+ farmers from Kaski, Lamjung, and Tanahu\n- **Rice & Grains**: 200+ farmers from Chitwan and Nawalparasi\n- **Dairy**: 50+ cooperatives providing fresh milk daily\n- **Poultry & Eggs**: Local suppliers meeting hygiene standards',
      '## The Numbers That Matter',
      '| Metric | Before Sarvaguna | After Sarvaguna |\n|--------|------------------|------------------|\n| Average farmer income | NPR 15,000/month | NPR 22,000/month |\n| Produce waste | 25-30% | 8-10% |\n| Payment delay | 30-45 days | 7-15 days |',
      '## Sustainable Agriculture',
      'We encourage sustainable farming practices:\n- Organic fertilizers and pesticides\n- Water conservation techniques\n- Crop rotation for soil health\n- Training programs for modern techniques',
      '## Join Our Network',
      'Are you a farmer looking for stable, fair-priced market access? Contact us at farmers@sarvagunakitchen.com to join our growing network.',
    ],
  },
  {
    slug: 'school-feeding',
    category: 'School Feeding',
    title: 'Transforming School Nutrition: How Sarvaguna is Feeding 4,500+ Students Daily',
    excerpt: 'Discover how our school feeding program is improving learning outcomes and nutrition for thousands of students across Pokhara. From farm-fresh ingredients to balanced meals, we ensure every child gets the nutrition they deserve.',
    body: [
      'At Sarvaguna Foods & Kitchen, we believe that good nutrition is the foundation of good education. Since 2022, we have been serving nutritious, balanced meals to over 4,500 students daily across 22 private schools and 3 public schools in Pokhara.',
      '## The Challenge',
      'Many students in Nepal come to school without having eaten breakfast. This affects their concentration, energy levels, and ultimately their learning outcomes. Research shows that students who eat well-balanced meals perform better academically and have improved attendance rates.',
      '## Our Solution',
      'We have developed a comprehensive school feeding program that focuses on:',
      '- **Locally Sourced Ingredients**: 51% of our produce comes directly from local farmers, ensuring freshness and supporting the local economy.\n- **Nutritionally Balanced Menus**: Our menus are designed by nutritionists to meet the dietary needs of growing children.\n- **Hygiene and Safety**: We follow strict food safety protocols in our HACCP-compliant central kitchen.\n- **Cultural Sensitivity**: Our meals incorporate traditional Nepali dishes that children love.',
      '## The Impact',
      'Since launching our program:\n- Improved school attendance by 15%\n- Reduced mid-day fatigue complaints by 40%\n- Connected 200+ local farmers to stable income\n- Created 50+ jobs in our community',
      '## Looking Ahead',
      'Our vision for 2030 is to serve 40,000 meals daily, connecting 6,500 farmers and creating 375 sustainable jobs. We are not just feeding children; we are building a sustainable food system that benefits everyone.',
      'Want to bring our school feeding program to your institution? Contact us at info@sarvagunakitchen.com.',
    ],
  },
];
export const footer = {
  blurb: 'Fresh, balanced meals for schools, hospitals and institutions. Built in Pokhara, growing across Nepal.',
  partnersLine: 'Partnerships: all of Nepal',
};
// ---------------------------------------------------------------- FOOD NETWORK MODEL
// Shown on How we work and in the funders section of Partner with us.
export const network = {
  title: 'Our food network model',
  lead: 'How food and income move between farmers, our central kitchen, the canteens and the people we feed.',
  nodes: [
    { img: 'farmers', title: 'Farmers', text: 'Local growers deliver their produce to our kitchen.' },
    { img: 'kitchen', title: 'Central kitchen', text: 'Storage, milling, cooking and packing under one roof.' },
    { img: 'hospital', title: 'Satellite kitchens/​canteens', text: 'Canteens and catering in schools, hospitals and at events.' },
    { img: 'hero', title: 'The people we feed', text: 'Students, patients, staff and guests, with meals matched to their health and taste.' },
  ],
  links: ['Fresh produce', 'Meals every day', 'Served fresh'],
  back: 'Farmers receive a fair income, agreed by contract.',
  academy: {
    img: 'academy',
    title: 'Sarvaguna Academy',
    text: 'Trains young people for jobs in the kitchen, and to run new satellite kitchens.',
  },
};
